import script from "./HallsManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./HallsManagement.vue?vue&type=script&setup=true&lang=js"

import "./HallsManagement.vue?vue&type=style&index=0&id=e49de6b0&scoped=true&lang=css"
import "./HallsManagement.vue?vue&type=style&index=1&id=e49de6b0&lang=css"

import exportComponent from "/codebuild/output/src4197/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e49de6b0"]])

export default __exports__